<template>
<span>
    <div v-if="adaptiveStart"/>
    <div class="odr-block-wrap"
         :class="{
             'odr-block-wrap_transparent': asTransparent,
             'odr-block-wrap_inline': innerWrap || adaptive,
             'odr-block-wrap_highlight': highlight,
         }"
         :style="`
            width: ${width}% !important;
         `">

        <slot/>
    </div>
    <div v-if="adaptiveEnd"/>
</span>
</template>

<script>
import '@/scss/blocks/block-wrap.scss';
import { mapState } from 'vuex';

export default {
    props: {
        adaptive: {},
        innerWrap: {},
        asTransparent: {},
        highlight: {},
        adaptiveEnd: {},
        adaptiveStart: {},
        fullWidth: {},
        takeWidth: {
            type: Number,
            default: 12,
        },
        parentTakeWidth: {
            type: Number,
            default: 12,
        },
        stepFieldsCount: {
            type: Number,
        },
    },
    computed: {
        ...mapState('dimensions', {
            dimensionsWidth: 'width',
        }),
        columns () {
            if (this.innerWrap) {
                return 1;
            }

            if (this.adaptive && this.stepFieldsCount) {
                const sidePaddings = 30;
                let columnsCount = this.$root.appConfig.numOfFieldsBreakPoints.length + 1;
                let foundIndex = [0, ...this.$root.appConfig.numOfFieldsBreakPoints].reverse().findIndex((fieldsCount, index) => {
                    return this.dimensionsWidth >= ((this.$root.appConfig.minColumnWidth * (columnsCount - index)) + sidePaddings) &&
                           this.stepFieldsCount > fieldsCount;
                });

                return foundIndex === -1 ? 1 : columnsCount - foundIndex;
            }

            return 1;
        },
        width () {
            if (this.fullWidth) { return 100; }
            return Math.min((this.takeWidth / this.parentTakeWidth) * (99.99 / this.columns), 99.99);
        },
    },
};
</script>
